import { getSintegradaServerApi } from "@/services/api";
import { OccupationPaginated } from "@/@types/sintegrada/OccupationPaginated";
import { InternalDepartmentParams } from "@/@types/sintegrada/InternalDepartmentParams";

export async function getDepartmentStabilizations({
	uf,
	ibgeCode,
	...params
}: InternalDepartmentParams) {
	const url = `/3/Occupation/department-stabilizations`;

	const { data } = await getSintegradaServerApi().get<OccupationPaginated>(url, {
		ibgeCode,
		...params,
	});

	return data || ({} as OccupationPaginated);
}
